import { openOtpModal, closeAllModals } from '../actions/modalActions';

// Bridge between the axios response interceptor (which lives outside React) and
// the Redux store, mirroring approvalBridge. A connected component
// (UtilsComponent) registers `dispatch` here on mount; the interceptor uses it
// to open the OTP modal and awaits the entered token.
let _dispatch = null;
let _pending = null;

export const registerAuthDispatch = (dispatch) => {
  _dispatch = dispatch;
};

// General-purpose escape hatch for non-React code (and connect()-free components)
// that need to dispatch a Redux action. Relies on UtilsComponent having registered
// dispatch first — safe to call from useEffect / async callbacks.
export const dispatchAction = (action) => {
  if (_dispatch) _dispatch(action);
};

// Called by the HTTP interceptor when a request returns `403 2fa-required`.
// Returns a Promise that resolves with the entered token, or `null` if the user
// cancels (or the auth UI isn't mounted yet). `error` is an optional message
// from a previous rejected attempt, shown so the user can retry the code without
// the original action being aborted.
export const requestOtp = (error = null) =>
  new Promise((resolve) => {
    if (!_dispatch) return resolve(null);
    _pending = resolve;
    _dispatch(openOtpModal(error));
  });

// Called by OtpModal when the user submits a token. The interceptor keeps the
// prompt open until verification succeeds (closeOtp) or the user cancels, so a
// rejected code can be re-prompted in place.
export const submitOtp = (token) => {
  if (_pending) {
    const resolve = _pending;
    _pending = null;
    resolve(token);
  }
};

// Called by the interceptor once a token verifies, to dismiss the prompt.
export const closeOtp = () => {
  if (_dispatch) _dispatch(closeAllModals());
};

// Called by OtpModal when the user dismisses the prompt.
export const cancelOtp = () => {
  if (_pending) {
    const resolve = _pending;
    _pending = null;
    resolve(null);
  }
  if (_dispatch) _dispatch(closeAllModals());
};
